import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pt-[20px] bg-[#ededed]" }
const _hoisted_2 = { class: "max-w-[1400px] w-full container mx-auto" }
const _hoisted_3 = {
  class: "pt-[60px] pr-[20px] pb-[2%] pl-[10px] max-w-[1400px]",
  id: "mediaNavigation"
}
const _hoisted_4 = { class: "max-w-[1400px] w-full container mx-auto" }
const _hoisted_5 = {
  class: "pt-[30px] pr-[20px] pb-[40px] pl-[10px] max-w-[1400px]",
  id: "mediaContent"
}

import { computed } from 'vue'
    import { useRoute } from 'vue-router'
    import mediaNavigation from '@/components/SubNavigations/TheMediaNavigation.vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Media',
  setup(__props) {

    const route = useRoute()

    // Generate breadcrumbs based on current route
    const breadcrumbs = computed(() => {
        const items = [
            {
                title: 'Media',
                disabled: false,
                href: '/media',
            },
        ]

        // Add video player breadcrumb if on player route
        if (route.name === 'VideoPlayer') {
            items.push({
                title: 'Video Player',
                disabled: route.params.id ? false : true,
                href: '/media/player',
            })

            // Add video ID breadcrumb if available
            if (route.params.id) {
                items.push({
                    title: `Video ${route.params.id}`,
                    disabled: true,
                    href: `/media/player/${route.params.id}`,
                })
            }
        }

        return items
    })

return (_ctx: any,_cache: any) => {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(mediaNavigation)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_v_breadcrumbs, { items: breadcrumbs.value }, null, 8, ["items"]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_view)
      ])
    ])
  ], 64))
}
}

})